<template>
  <v-container fluid class="text-center">
    <v-card class="elevation-5 mt-5">
      <v-toolbar dense dark color="secondary" elevation="2">
        <v-toolbar-title>
          Reportes
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text small :disabled="loading || !items.length" @click="exportData()">
          Exportar
          <v-icon right>mdi-arrow-down</v-icon>
        </v-btn>
        <v-btn text small :disabled="loading || !isReading" @click="refresh()">
          Consultar
          <v-icon right>mdi-magnify</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-row>
          <v-col cols="12" md="2">
            <v-select v-model="form.tipo" :items="catalogues.tipos" item-text="text" item-value="value" prepend-icon="mdi-file"
            label="Tipo" class="mx-2" :disabled="loading" required @change="setType()"></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-dialog ref="startDialog" v-model="dialogs.startDate" :return-value.sync="form.fechaInicio" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="form.fechaInicio" label="Fecha inicio" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="form.fechaInicio" locale="es" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dialogs.startDate = false">
                  Cancelar
                </v-btn>
                <v-btn text color="primary" @click="$refs.startDialog.save(form.fechaInicio)">
                  Aceptar
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="2">
            <v-dialog ref="endDialog" v-model="dialogs.endDate" :return-value.sync="form.fechaFin" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="form.fechaFin" label="Fecha Fin" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="form.fechaFin" locale="es" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dialogs.endDate = false">
                  Cancelar
                </v-btn>
                <v-btn text color="primary" @click="$refs.endDialog.save(form.fechaFin)">
                  Aceptar
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-show="form.tipo === 'asistencia'" v-model="form.evento" :items="catalogues.eventos" item-text="nombre" item-value="eventoID"
            prepend-icon="mdi-calendar-star" label="Eventos" class="mx-2" persistent-hint></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
      :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [20, 50, -1] }" :items-per-page="10" item-key="id" class="elevation-1" dense>
        <v-progress-linear slot="progress" color="secondary" indeterminate></v-progress-linear>
        <template v-slot:footer.page-text="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template v-slot:no-data>
          No hay información disponible
        </template>
        <template v-slot:no-results>
          No se obtuvieron resultados
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
  </v-container>
</template>

<script>
import services from '@/utils/services'
import moment from 'moment-timezone'
import writeXlsxFile from 'write-excel-file'
import _ from 'lodash'

export default {
  name: 'reports',
  data: () => ({
    loading: false,
    success: false,
    msgSuccess: '',
    error: false,
    msgError: '',
    search: '',
    catalogues: {
      tipos: [
        { text: 'Eventos', value: 'eventos' },
        { text: 'Asistencia', value: 'asistencia' },
      ],
      eventos: []
    },
    headers: [],
    headersEvent: [
      { text: 'ID de evento', align: 'left', sortable: false, value: 'id' },
      { text: 'Fecha de inicio', align: 'left', sortable: false, value: 'fecha_inicio' },
      { text: 'Fecha fin', align: 'left', sortable: false, value: 'fecha_fin' },
      { text: 'Fecha de finalizado', align: 'left', sortable: false, value: 'fecha_finalizado' },
      { text: 'Nombre del evento', align: 'left', sortable: false, value: 'nombre_evento' },
      { text: 'Nombre del instructor', align: 'left', sortable: false, value: 'nombre_instructor' },
      { text: 'Ubicación', align: 'left', sortable: false, value: 'ubicacion' },
      { text: 'Región', align: 'left', sortable: false, value: 'region' },
      { text: 'País', align: 'left', sortable: false, value: 'pais' },
      { text: 'Capacidad máxima', align: 'left', sortable: false, value: 'capacidad_maxima' },
      { text: 'Asistentes', align: 'left', sortable: false, value: 'asistentes' },
      { text: 'Porcentaje de usuarios puntuales', align: 'left', sortable: false, value: 'porcentaje_puntualidad' },
      { text: 'Fecha de primer registro de asistencia', align: 'left', sortable: false, value: 'fecha_primer_registro_asistencia' },
      { text: 'Fecha de último registro de asistencia', align: 'left', sortable: false, value: 'fecha_ultimo_registro_asistencia' },
      { text: 'Nombre de empleado creador', align: 'left', sortable: false, value: 'nombre_empleado_creador' },
      { text: 'Fecha de creación', align: 'left', sortable: false, value: 'fecha_creacion' },
      { text: 'Rol de empleado creador', align: 'left', sortable: false, value: 'rol_empleado_creador' },
    ],
    headersAttendance: [
      { text: 'ID de evento', align: 'left', sortable: false, value: 'evento_id' },
      { text: 'Fecha de inicio', align: 'left', sortable: false, value: 'evento_fecha_inicio' },
      { text: 'Fecha fin', align: 'left', sortable: false, value: 'evento_fecha_fin' },
      { text: 'Fecha de finalizado', align: 'left', sortable: false, value: 'evento_fecha_finalizado' },
      { text: 'Nombre del evento', align: 'left', sortable: false, value: 'evento_nombre_evento' },
      { text: 'Nombre del instructor', align: 'left', sortable: false, value: 'evento_nombre_instructor' },
      { text: 'Ubicación', align: 'left', sortable: false, value: 'evento_ubicacion' },
      { text: 'Región', align: 'left', sortable: false, value: 'evento_region' },
      { text: 'País', align: 'left', sortable: false, value: 'evento_pais' },
      { text: 'ID de empleado', align: 'left', sortable: false, value: 'asistencia_id_empleado' },
      { text: 'Nombre del asistente', align: 'left', sortable: false, value: 'asistencia_nombre_empleado' },
      { text: 'Fecha y hora de asistencia', align: 'left', sortable: false, value: 'asistencia_fecha_creacion' },
      { text: 'Ubicación del asistente', align: 'left', sortable: false, value: 'asistencia_ubicacion' },
      { text: 'Región del asistente', align: 'left', sortable: false, value: 'asistencia_region' },
      { text: 'País del asistente', align: 'left', sortable: false, value: 'asistencia_pais' },
      { text: 'Departamento del asistente', align: 'left', sortable: false, value: 'asistencia_departamento' },
      { text: 'Dirección del asistente', align: 'left', sortable: false, value: 'asistencia_dirección' },
      { text: 'Nombre del empleado que capturó asistencia', align: 'left', sortable: false, value: 'asistencia_empleado_creador' },
      { text: 'Código de Elevate', align: 'left', sortable: false, value: 'asistencia_codigo_elevate' },
    ],
    items: [],
    selected: [],
    form: {
      tipo: null,
      fechaInicio: '',
      fechaFin: '',
      evento: null
    },
    dialogs: {
      startDate: false,
      endDate: false
    }
  }),
  computed: {
    isReading: function() {
      return services.check(1, this.$route.path);
    }
  },
  mounted() {
    this.getCatalogues()
  },
  methods: {
    async getCatalogues() {
      const event = await this.axios.get(services.routes.eventos)
      if (event.data.data) {
        this.catalogues.eventos = event.data.data
      }
    },
    setType() {
      if (this.form.tipo === 'eventos') {
        this.headers = this.headersEvent
      }
      else if (this.form.tipo === 'asistencia') {
        this.headers = this.headersAttendance
      }
      this.items = []
    },
    refresh() {
      if (this.form.tipo) {
        if (this.form.fechaInicio !== '' && this.form.fechaFin !== '') {
          this.loading = true
          const report = (this.form.tipo === 'eventos')? 'event' : 'attendance'
          let params = {
            fechaInicio: moment(this.form.fechaInicio + ' 00:00').utc().format(),
            fechaFin: moment(this.form.fechaFin + ' 23:59').utc().format(),
            evento: this.form.evento
          }
          this.axios.get(services.routes.reportes + '/' + report, { params })
            .then(response => {
              this.items = response.data.data
            })
            .catch(error => {})
            .finally(() => {
              this.loading = false
            })
        }
        else {
          this.error = true
          this.msgError = 'Debe seleccionar una fecha inicio y una fecha fin'
        }
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar un tipo de reporte'
      }
    },
    exportData() {
      let data = []
      let headers = []
      for (let i = 0; i < this.headers.length; i++) {
        headers.push({
          value: this.headers[i].text,
          fontWeight: 'bold'
        })
      }
      data.push(headers)
      for (let i = 0; i < this.items.length; i++) {
        let rows = []
        for (let j = 0; j < this.headers.length; j++) {
          let key = this.headers[j].value
          rows.push({
            type: String,
            value: (!_.isNil(this.items[i][key])) ? this.items[i][key].toString() : ''
          })
        }
        data.push(rows)
      }
      writeXlsxFile(data, { fileName: 'Reporte de ' + this.form.tipo + '.xlsx' })
    }
  },
}
</script>

<style scoped>
</style>
